module.exports = __webpack_public_path__ + "static/img/logo-img.eb9225e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-img.png
// module id = 2Xsp
// module chunks = 6